import { towns } from "@/data/services";

export default function Marquee() {
  const items = [...towns, "the St. Clair Corridor"];
  const row = [...items, ...items];
  return (
    <div className="overflow-hidden border-y border-[#043B1C]/10 bg-[#F4F6F3] py-5" data-testid="towns-marquee">
      <div className="marquee-track flex w-max items-center gap-10">
        {row.map((town, i) => (
          <span key={i} className="flex items-center gap-10 whitespace-nowrap">
            <span className="text-sm font-bold uppercase tracking-[0.22em] text-[#043B1C]">
              Proudly serving {town}
            </span>
            <span className="h-1.5 w-1.5 rounded-full bg-[#F4BE36]" />
          </span>
        ))}
      </div>
    </div>
  );
}
